import * as types from "./actionTypes";
import indienenVoortgangsrapportApi from "../api/indienenVoortgangsrapportApi";
import * as ajax from "./ajaxCounterActions";
import * as exception from "./exceptionActions";
import * as constants from "../constants/DomainConstants";
import * as beads from "./beadActions";

// ----------------------------------------------------------------------------
export function indienenLoaded(indienen) {
	return {
		type: types.INDIENEN_LOADED,
		body: indienen
	};
}

export function loadIndienen(voortgangsrapportId) {
	return function (dispatch) {
		dispatch(ajax.started());

		return indienenVoortgangsrapportApi.get(voortgangsrapportId)
			.then(response => {
				return handleIndienenResponse(dispatch, response.data);
			}).catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}

export function confirmIndienen(voortgangsrapportId) {
	return function (dispatch) {
		dispatch(ajax.started());

		return indienenVoortgangsrapportApi.confirm(voortgangsrapportId)
			.then(response => {
				return handleIndienenResponse(dispatch, response.data);
			}).catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}

function handleIndienenResponse(dispatch, data) {
	dispatch(ajax.ended());
	dispatch(indienenLoaded(data));
	dispatch(beads.beadsLoaded(data.beadModels));

	let isIngediend;
	if (data.status == constants.REDEN_VAN_STATUS_INGEDIEND)
		isIngediend = true;
	else
		isIngediend = false;

	return isIngediend;
}

export function generatePdf(voortgangsrapportId) {
	return function (dispatch) {
		dispatch(ajax.started());

		return indienenVoortgangsrapportApi.generatePdf(voortgangsrapportId)
			.then(response => {
				dispatch(ajax.ended());
				dispatch(beads.beadsLoaded(response.data.item.beadModels));
				return true;
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
				return false;
			});
	};
}